export enum MeasurementLinesVisibility {
  ShowAll = 'show-all',
  HideAll = 'hide-all',
  HorizontalOnly = 'horizontal-only',
  VerticalOnly = 'vertical-only',
  Version2 = 'version-2',
}
